export const TIME_SHEET_COLUMNS_DEFAULT_PARAMS = Object.freeze({
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  status: undefined,
  hasPendingLeave: undefined,
});

export const TIME_SHEET_FILTER_FORM_DEFAULT_PARAMS = Object.freeze({
  createdAt: undefined,
  updatedAt: undefined,
  'employmentSettings.employmentType': undefined,
  includeNonEmployment: undefined,
});

export const TIME_SHEET_OVERVIEW_DEFAULT_PARAMS = Object.freeze({
  // View mode: 'table' | 'overview' | 'list'
  viewMode: 'table',
  // Density: 'auto' | 'daily' | 'weekly'
  densityMode: 'auto',
  // Multi-month period range; defaults match single-month current
  monthFrom: new Date().getMonth() + 1,
  yearFrom: new Date().getFullYear(),
  monthTo: new Date().getMonth() + 1,
  yearTo: new Date().getFullYear(),
  // Extended filters (overview/list only — table view ignores)
  sectorIds: undefined,
  employeeIds: undefined,
  employeeStatuses: undefined,
  employmentTypes: undefined,
  workTimeTypes: undefined,
  workTypes: undefined,
  salaryStatuses: undefined,
  attachmentTypes: undefined,
  isHrOfficer: undefined,
  isLocked: undefined,
  hasLeaveOnly: undefined,
  hasAttachmentsOnly: undefined,
  hasTimeTrackingOnly: undefined,
  hasOvertimeOnly: undefined,
  search: undefined,
});

export const TIME_SHEET_DEFAULT_PARAMS = Object.freeze({
  offset: '1',
  limit: '10',
  company: null,
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear(),
  typeOfLeaveSelect: 'holidayLeave',

  // Filters
  personalNo: undefined,

  // Sorters
  sortFirstName: undefined,
  sortLastName: undefined,
  sortUpdatedAt: undefined,
  sortStatus: undefined,
  sortCountry: undefined,

  ...TIME_SHEET_COLUMNS_DEFAULT_PARAMS,
  ...TIME_SHEET_FILTER_FORM_DEFAULT_PARAMS,
  ...TIME_SHEET_OVERVIEW_DEFAULT_PARAMS,
});
